import Container from 'typedi';
import ActivityRepository from '../repositories/ActivityRepository';
import DocumentService from './DocumentService';
class ActivityService {
  documentService;
  activityRepository;
  constructor() {
    this.documentService = Container.get(DocumentService);
    this.activityRepository = Container.get(ActivityRepository);
  }
  getActivities = async (page, rowsPerPage) => await this.activityRepository.getActivities(page, rowsPerPage);
  getActivitiesByIdTrip = async (idTrip) => await this.activityRepository.getActivityByIdTrip(idTrip);

  processMassiveActivitySubmission(activities, activityTypes, itemTypes, tags) {
    const requestActivities = [];
    if (activities.length) {
      activities.forEach((activity) => {
        activity.activityName = typeof activity.activityName == 'string' ? activity.activityName.replace(/'/g, '') : activity.activityName;
        
        const specificActivity = activityTypes.find((e) => e.text === activity.activityType);
        const tag = activity.tag ? [tags.find((filterTag) => filterTag.name === activity.tag)] : [];
        const requestDocuments = activity.documents
          ? this.documentService.processMassiveDocumentSubmission(activity.documents, itemTypes)
          : [];
        const activityBody = {
          name: activity.activityName,
          type: specificActivity.value,
          duration: Math.round(Number(activity.duration)) * 60,
          weight: activity.weight ? this.activityRepository.convertirADosDigitos(activity.weight) : '',
          volume: activity.volume ? this.activityRepository.convertirADosDigitos(activity.volume) : '',
          tags: tag,
          customerName: activity.customerName ? activity.customerName : null,
          customerLegalNumber: activity.customerLegalNumber ? activity.customerLegalNumber : null,
          customerPhone: activity.customerPhone ? activity.customerPhone : null,
          customerEmail: activity.email ? activity.email : null,
          documents: requestDocuments,
        };
        requestActivities.push(activityBody);
      });
    }
    return requestActivities;
  }
}

Container.set({ id: ActivityService, type: ActivityService });

export default ActivityService;
